import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  FollowGroupActionsUnion,
  FollowGroupActionTypes
} from '@core/actions/follow-group.actions';
import { FollowGroup } from '@app/models/follow-group';
import { comparerByAlphabet } from '@app/comparers';

export interface State extends EntityState<FollowGroup> {
  loading: boolean;
  loaded: boolean;
  advancedFilters: any[];
  filters: any[];
}

export const adapter: EntityAdapter<FollowGroup> = createEntityAdapter<
  FollowGroup
>({
  selectId: (followGroup: FollowGroup) => followGroup.id,
  sortComparer: comparerByAlphabet('ASC', 'name')
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  advancedFilters: [],
  filters: [],
});

export function reducer(
  state: State = INITIAL_STATE,
  action: FollowGroupActionsUnion
) {
  switch (action.type) {
    case FollowGroupActionTypes.Load:
      return { ...state, loading: true };

    case FollowGroupActionTypes.LoadFail:
      return { ...state, loading: false };

    case FollowGroupActionTypes.LoadSuccess:
      return adapter.addAll(action.followGroups, {
        ...state,
        loading: false,
        loaded: true
      });
    
    case FollowGroupActionTypes.Filter:
      return {
        ...state,
        filters: [
          ...state.filters.filter(
            (id => id.valueCondition !== action.key.valueCondition) &&
              (key => key.condition === action.key.condition)
          ),
          action.key
        ]
      }

      case FollowGroupActionTypes.FilterClear:
          return {
            ...state,
            filters: state.filters.filter(
              item => item.valueCondition !== action.key.valueCondition
            )
          };

    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const selectFilters = (state: State) => state.filters;
export const getState = createFeatureSelector<State>('followGroups');



export const getFilters = createSelector(
  getState,
  selectFilters
);

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;
